import { apiService as api } from '@afterpaytouch/portal-api/api'
import { createPortalApi, createTopazApi, createShopApi, createVerifyServiceApi, createVerifyServiceClient } from './request'
import { apiService as topaz } from '@afterpaytouch/topaz-api/api'
import { apiService as shop } from '@afterpaytouch/shop-api/api'

export const apiService = api.setBaseQueryFn(createPortalApi())

export const { reducer: apiReducer, middleware: apiMiddleware } = apiService.service

export const topazService = topaz.setBaseQueryFn(createTopazApi())

export const { reducer: topazReducer, middleware: topazMiddleware } = topazService.service

export const shopService = shop.setBaseQueryFn(createShopApi())

export const { reducer: shopReducer, middleware: shopMiddleware } = shopService.service

export const verifyServiceApi = createVerifyServiceApi()

export const verifyServiceClient = createVerifyServiceClient()
